import * as React from 'react';
import LockResetIcon from '@mui/icons-material/LockReset';
import {
  Alert,
  Box,
  Collapse,
  IconButton,
  InputAdornment,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Modal,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import CustomButton from '../customButton/CustomButton';
import Close from '@mui/icons-material/Close';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axiosInstance from '../../configs/axios';
import { ApiPath } from '../../constants/apiPath';
import { axiosErrorMessage } from '../../utils/error-message';
import { AxiosError } from 'axios';
import lineLoader from '../lineLoader/lineLoader';
import checkAuthController from '../../layouts/dashboard/controllers/check-auth.controller';
import { UserInfoModel } from '../../pages/user/models/user.model';
import logoutController from '../../layouts/dashboard/controllers/logout.controller';

export interface ChangePasswordModalProps {
  onCloseMenuProfile: () => void;
}
export default function ChangePasswordModal({ onCloseMenuProfile }: ChangePasswordModalProps) {
  const checkUser = checkAuthController();
  const logout = logoutController();
  const [showPassword, setShowPassword] = React.useState<boolean>(false);
  const [showPassword2, setShowPassword2] = React.useState<boolean>(false);
  const [open, setOpen] = React.useState<boolean>(false);
  const [oldpass, setOldPass] = React.useState<string>('');
  const [newpass, setNewPass] = React.useState<string>('');
  const [message, setMessage] = React.useState<string>('');
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    checkUser.getLoginUser();
  }, []);

  const handleSubmit = async () => {
    try {
      const user: UserInfoModel | null = checkUser.loginUser;

      if (user === null) return setMessage('ປ່ຽນລະຫັດຜ່ານບໍ່ສຳເລັດ, ບໍ່ພົບຂໍ້ມູນຜູ້ໃຊ້');
      setLoading(true);

      const response = await axiosInstance.post(ApiPath.auth.resetPassword, {
        oldPassword: oldpass,
        newPassword: newpass,
        username: user['username'],
      });

      if (response.status === 200) {
        setMessage('ປ່ຽນລະຫັດຜ່ານສຳເລັດ');
        setOldPass('');
        setNewPass('');
        logout.logout();
      } else {
        setMessage('ປ່ຽນລະຫັດຜ່ານບໍ່ສຳເລັດ');
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setMessage(axiosErrorMessage({ error: error as AxiosError }));
    }
  };

  return (
    <React.Fragment>
      <MenuItem
        onClick={() => {
          onCloseMenuProfile();
          setTimeout(() => {
            setOpen(true);
          }, 300);
        }}
      >
        <ListItemText sx={{ paddingRight: '20px' }}>ປ່ຽນລະຫັດຜ່ານ</ListItemText>
        <ListItemIcon>
          <LockResetIcon />
        </ListItemIcon>
      </MenuItem>
      <Modal
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflowY: 'auto' }}
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box
          sx={{
            bgcolor: 'white',
            maxWidth: '500px',
            minWidth: '300px',
            borderRadius: '12px',
            maxHeight: { xs: '90vh' },
            overflow: 'hidden',
            paddingLeft: 4,
            paddingBottom: 4,
          }}
        >
          <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
            <Typography paddingTop={4} fontSize="24px">
              ປ່ຽນລະຫັດຜ່ານ
            </Typography>
            <Box paddingTop={'10px'} width={'50px'} height={'50px'}>
              <IconButton onClick={() => setOpen(false)}>
                <Close />
              </IconButton>
            </Box>
          </Box>
          <Typography>ກະລຸນາໃສ່ລະຫັດຜ່ານເກົ່າເພື່ອປ່ຽນລະຫັດ.</Typography>
          <br />
          <Box paddingRight={4}>
            <Collapse unmountOnExit={true} orientation={'vertical'} in={loading ? true : false}>
              {lineLoader()}
            </Collapse>
            <Collapse
              unmountOnExit={true}
              orientation={'vertical'}
              in={message != '' ? true : false}
            >
              <Alert sx={{ paddingRight: 4, marginBottom: '10px' }} severity={'error'}>
                {message ?? ''}
              </Alert>
            </Collapse>
          </Box>
          <form
            onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
              event.preventDefault();
            }}
          >
            <Stack paddingRight={4} spacing={2}>
              <TextField
                required
                fullWidth
                size="small"
                type={showPassword ? 'text' : 'password'}
                InputLabelProps={{ shrink: true }}
                label="ລະຫັດເກົ່າ"
                placeholder="********"
                value={oldpass}
                onChange={(e) => {
                  setOldPass(e.target.value);
                  setMessage('');
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        aria-label="toggle password visibility"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                required
                fullWidth
                size="small"
                type={showPassword2 ? 'text' : 'password'}
                InputLabelProps={{ shrink: true }}
                label="ລະຫັດໃໝ່"
                placeholder="********"
                value={newpass}
                onChange={(e) => {
                  setNewPass(e.target.value);
                  setMessage('');
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword2(!showPassword2)}
                        aria-label="toggle password visibility"
                      >
                        {showPassword2 ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <br />
              <CustomButton label="ປ່ຽນລະຫັດ" handleOpenDialog={handleSubmit} />
            </Stack>
          </form>
        </Box>
      </Modal>
    </React.Fragment>
  );
}
